export default __webpack_public_path__ + "static/media/metamask.bbddb4f4.svg";